// extracted by mini-css-extract-plugin
export default {"container":"PollAttachmentIcon_container__yJ5Iv","icon":"PollAttachmentIcon_icon__28Ckt","image":"PollAttachmentIcon_image__bvuaM"};